import GalleryManager from '../core/gallery/GalleryManager';

export default {

	// isTouchDevice: function () {
	// 	return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
	// }
	supportTouch: null,


	isTouchDevice: function () {

		// check touch suppor only once
		if (this.supportTouch == null) {
			const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
			const mq = function (query) {
				return window.matchMedia(query).matches;
			};

			if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
				return true;
			}

			// include the 'heartz' as a way to have a non matching MQ to help terminate the join
			// https://git.io/vznFH
			const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
			this.supportTouch = mq(query);
		}

		return this.supportTouch;
	},

	isLocal: function() {
		return window.location.href.indexOf("localhost") >= 0;
	},

	isTextViewEnabled: function () {
		if (this.designerSettings) {
			return this.designerSettings.TextOnImage.Enabled;
		}
	},

	isLogoViewEnabled: function () {
		if (this.designerSettings) {
			return this.designerSettings.LogoEnabled !== true && this.designerSettings.Coverage.Logo != null;
		}
	},

	isMonoGramEnabled : function(){
		if (this.designerSettings) {
			//return this.designerSettings.Coverage.LogoEnabled !== null;

			return this.isLocal();
		}
	},

	isClipArtEnabled: function () {
		if (this.designerSettings) {
			//return this.designerSettings.ClipArtEnabled === true;
			return this.designerSettings.Coverage.ClipArt !== null;
		}
	},

	isOverlayEnabled: function () {
		if (this.designerSettings) {
			this.galleryManager = new GalleryManager();
			let dropdownValues = this.galleryManager.getOverlayImages().map(item => {
				return { name : item.Name }
			});
			return dropdownValues.length > 0 ? true : false;
		}
	},
	
	isDataCaptureEnabled: function () {
		if (this.designerSettings) {
			return this.designerSettings.DataCapture.CustomDataCaptureEnabled === true;
		}
	},

	isEmailCaptureEnabled: function () {
		if (this.designerSettings) {
			const emailCap = this.designerSettings.DataCapture.EmailCapture;
			return emailCap === 'Enabled' || (emailCap === 'CustomOnly'  & this.isCustomImage);
		}
	},

	isFacebookEnabled: function () {
		if (this.designerSettings) {
			return this.designerSettings.FacebookAppId && this.designerSettings.EnableFacebookButton;

		}
	},

	isSpecialEffectsEnabled: function () {
		if (this.designerSettings) {
			return this.designerSettings.SpecialEffects && this.designerSettings.SpecialEffects.Enabled === true && this.designerSettings.SpecialEffects.Effects.length > 0;

		}
	},
	isDoodleEnabled: function () {
		if (this.designerSettings) {
			return this.designerSettings.Coverage.Doodle && this.designerSettings.Coverage.Doodle.LayerCategory === 'Doodle';

		}																		 
	},
	isUndoEnabled: function () {
		if (this.designerSettings) {
			/* KBCResponsive skin only have undo feature -
			 	Its temp solution to get rid of undo code if designer doesn't have undo feature
				We will change when undo control option will be available from product setting as skin feature 
			*/
			return this.designerSettings.Skin.Name ==='KBCResponsive';
		}
	},
	isGalleryEnabled: function () {
		if (this.designerSettings) {
			return this.designerSettings.Galleries && this.designerSettings.Galleries.Enabled === true;
		}
	},
	isSignatureEnabled: function () {
		if(this.designerSettings) {
			return this.designerSettings.Coverage.Signature != null;
		}
	},
	isSkinSpecificCustomization: function () {
		if(this.designerSettings) {
			return this.designerSettings.SkinSpecificCustomization;
		}
	}
};